import React from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from "./bottom_panel.module.css";
import { useSelector } from "react-redux";
import { ReactComponent as Cart } from "../../../images/cart.svg";
import { ReactComponent as Heart } from "../../../images/heart.svg";
import { ReactComponent as Home } from "../../../images/home.svg";
import { ReactComponent as Catalog } from "../../../images/catalog.svg";
import { ReactComponent as Login } from "../../../images/login.svg";
import { ReactComponent as Register } from "../../../images/register.svg";
import { useDispatch } from "react-redux";
import { deleteAllCookies } from "../../../utils/cookie";
import { LOGOUT } from "../../../services/actions/user_actions";
import { CLEAR_ORDERS } from "../../../services/actions/orders_actions";
import { RESET_CUSTOMER } from "../../../services/actions/customer_actions";
import { RESET_FIRMS } from "../../../services/actions/firms_actions";
import { CLEAR_PROFILE_FORM } from "../../../services/actions/profile_form_actions";
import { CLEAR_CART } from "../../../services/actions/cart_actions";
import { getProductsThunk } from "../../../services/actions/products_actions";
import { getUser } from "../../../services/selectors";
import { CLEAR_FAV } from "../../../services/actions/fav_actions";
import { RESET_FIND_USER_INPUT } from "../../../services/actions/find_user_actions";


function BottomPanel() {

  const user = useSelector(getUser);

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch({ type: LOGOUT });
    dispatch({ type: RESET_CUSTOMER });
    dispatch({ type: RESET_FIRMS });
    dispatch({ type: CLEAR_ORDERS});
    dispatch({ type: CLEAR_FAV })
    dispatch({ type: RESET_FIND_USER_INPUT });
    dispatch(getProductsThunk('', ''));
    dispatch({ type: CLEAR_PROFILE_FORM });
    dispatch({ type: CLEAR_CART });
    navigate('/', { replace: true });
    deleteAllCookies();
  }

  return (
    <nav className={`${(user.loggedIn && user.is_active) ? styles.bottomPanel : styles.bottomPanelAnon}`}>
      <NavLink to='/' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
        <Home className={`${location.pathname === '/' ? styles.icon : styles.icon__noactive}`} style={{ position: "relative", bottom: "-3px" }} />
        Главная
      </NavLink>
      <NavLink to='/catalog' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
        <Catalog className={`${location.pathname === '/catalog' ? styles.icon : styles.icon__noactive}`} style={{ position: "relative", bottom: "-4px" }} />
        Каталог
      </NavLink>

      {user.loggedIn && user.is_active &&
        <>
          <NavLink to='/cart' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
            <Cart className={`${location.pathname === '/cart' ? styles.icon : styles.icon__noactive}`} />
            Корзина
            <p className={`${location.pathname === '/cart' ? styles.countCircle : styles.countCircle__noactive}`}>
              66
            </p>
          </NavLink>
          <NavLink to='/favorite' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
            <Heart className={`${location.pathname === '/favorite' ? styles.icon : styles.icon__noactive}`} />
            Избранное
            <p className={`${location.pathname === '/favorite' ? styles.countCircle : styles.countCircle__noactive}`}>
              99
            </p>
          </NavLink>
        </>
      }

      {user.loggedIn && user.is_active ?
        <button
          className={`${styles.button}`}
          onClick={handleLogout}
        >
          Выйти</button> :
        <>
          <NavLink to='/login' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
            <Login className={`${location.pathname === '/login' ? styles.icon : styles.icon__noactive}`} style={{ position: "relative", bottom: "-3px" }} />
            Войти
          </NavLink>
          <NavLink to='/register' className={({ isActive }) => isActive ? styles.link__active : styles.link}>
            <Register className={`${location.pathname === '/register' ? styles.icon : styles.icon__noactive}`} style={{ position: "relative", bottom: "-3px" }} />
            Регистрация
          </NavLink>
        </>
      }
    </nav>
  );
};

export default BottomPanel;
